export const STORAGE_BUCKETS = Object.freeze({
  BLOG_IMAGES: 'blog-images',
  PATTERN_IMAGES: 'patterns-images',
  PATTERN_PDFS: 'patterns-pdf',
});

export const STORAGE_BUCKET_CONFIG = Object.freeze([
  { id: STORAGE_BUCKETS.BLOG_IMAGES, public: true },
  { id: STORAGE_BUCKETS.PATTERN_IMAGES, public: true },
  { id: STORAGE_BUCKETS.PATTERN_PDFS, public: true },
]);
